'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = undefined;

var _factory = require('./factory');

var clientFactory = _interopRequireWildcard(_factory);

var _schemas = require('./schemas');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var create = exports.create = function create() {
  var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var parsedDependencies = _schemas.clientDependenciesSchema.normalize(dependencies);
  _schemas.clientDependenciesSchema.validate(parsedDependencies, '"createClient"', function (err) {
    /* Rethrow to break execution thread */
    throw err;
  });

  return clientFactory.create(parsedDependencies);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.70/js/client/index.js
// module id = 385
// module chunks = 0